import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface NavigationContextValue {
    isRefresh: boolean;
}

const NavigationContext = createContext<NavigationContextValue | undefined>(undefined);

interface NavigationProviderProps {
    children: React.ReactNode;
}

export const NavigationProvider: React.FC<NavigationProviderProps> = ({ children }) => {
    const [isRefresh, setIsRefresh] = useState(false);
    const [prevLocationKey, setPrevLocationKey] = useState('');
    const location = useLocation();
    useEffect(() => {
        if (location.key?.length > 0) {
            setIsRefresh(location.key.includes(prevLocationKey));
            setPrevLocationKey(location.key);
        }
    }, [location]);

    return <NavigationContext.Provider value={{ isRefresh }}>{children}</NavigationContext.Provider>;
};

export const useCustomNavigation = () => {
    const value = useContext(NavigationContext);
    if (value === undefined) {
        throw new Error('useCustomNavigation must be used within a <NavigationProvider>');
    }
    return value;
};
